function isArrayEmpty(arr) {
  var num = 0;
  arr.forEach((item) => {
    if (parseFloat(item) >= 0) {
      num++;
    }
  });
  return (num === 0);
}
export default {
  install: function (Vue, options) {
    Vue.prototype.$chartFromJson = function (option) {
      var newOption = {};
      switch (option.chartType) {
        case 'BarChart':
          newOption.chartOption = {
            title: {
              show: option.data.isShowTitle,
              text: option.data.title || '图表标题',
              left: 'center',
              top: 'top',
              textStyle: {
                fontFamily: option.style.titleFormat.fontFamily,
                fontSize: option.style.titleFormat.fontSize,
                color: option.style.titleFormat.foreground,
                fontWeight: (option.style.titleFormat.isBold ? 'bold' : 'normal')
              }
            },
            color: option.style.colorSpace,
            legend: {
              show: option.data.isShowLegend,
              orient: (option.data.legendPosition === 0 ? 'vertical' : 'horizontal'),
              left: (option.data.legendPosition === 0 ? 'right' : 'center'),
              top: (option.data.legendPosition === 0 ? 'middle' : 'bottom'),
              align: 'left',
              textStyle: {
                fontFamily: option.style.legendStyle.labelFormat.fontFamily,
                fontSize: option.style.legendStyle.labelFormat.fontSize,
                color: option.style.legendStyle.labelFormat.foreground,
                fontWeight: (option.style.legendStyle.labelFormat.isBold ? 'bold' : 'normal')
              },
              itemWidth: option.style.legendStyle.colorBlockWidth,
              itemHeight: option.style.legendStyle.colorBlockHeight,
              data: []
            },
            grid: {
              bottom: (option.data.legendPosition === 0 ? 30 : 50),
              // height: option.style.axisStyle.dataAreaHeight
            },
            animation: false,
            xAxis: {
              type: 'category',
              boundaryGap: [0, 0.01],
              // name: '商品名称',
              // nameGap: 30,
              // nameLocation: 'center',
              data: [],
              axisLabel: {
                show: option.data.isShowGroupLabels,
                interval: 0,
                fontFamily: option.style.groupLabelFormat.fontFamily,
                fontSize: option.style.groupLabelFormat.fontSize,
                color: option.style.groupLabelFormat.foreground,
                fontWeight: (option.style.groupLabelFormat.isBold ? 'bold' : 'normal')
              },
              axisLine: {
                onZero: false,
                symbol: ['none', 'arrow'],
                symbolSize: [option.style.axisStyle.arrowWidth, option.style.axisStyle.arrowHeight],
                lineStyle: {
                  width: option.style.axisStyle.lineWidth,
                  color: option.style.axisStyle.lineColor
                }
              },
              axisTick: {
                show: false,
                alignWithLabel: true
              },
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                interval: 0,
                fontFamily: option.style.axisStyle.valueMarkerFormat.fontFamily,
                fontSize: option.style.axisStyle.valueMarkerFormat.fontSize,
                color: option.style.axisStyle.valueMarkerFormat.foreground,
                fontWeight: (option.style.axisStyle.valueMarkerFormat.isBold ? 'bold' : 'normal')
              },
              axisLine: {
                symbol: ['none', 'arrow'],
                symbolSize: [option.style.axisStyle.arrowWidth, option.style.axisStyle.arrowHeight],
                lineStyle: {
                  width: option.style.axisStyle.lineWidth,
                  color: option.style.axisStyle.lineColor
                }
              },
              axisTick: {
                inside: true,
                lineStyle: {
                  width: option.style.axisStyle.valueMarkerLineLength,
                }
              },
              splitLine: {
                show: false
              }
            },
            series: []
          };
          option.data.data[0].forEach(function (value, index) {
            if (parseFloat(value) >= 0) {
              newOption.chartOption.xAxis.data.push(option.data.groupLabels[index]);
            }
          });
          option.data.legendItemLabels.forEach(function (serie, index) {
            if (!option.data.data[index]) {
              return;
            }
            if (!isArrayEmpty(option.data.data[index])) {
              newOption.chartOption.legend.data.push({
                name: serie,
                icon: 'rect'
              });
              newOption.chartOption.series.push({
                type: 'bar',
                data: option.data.data[index],
                name: serie,
                label: {
                  show: option.data.isShowDataValues,
                  position: 'insideTop',
                  color: option.style.dataLabelFormat.foreground,
                  fontSize: option.style.dataLabelFormat.fontSize,
                  fontWeight: (option.style.dataLabelFormat.isBold ? 'bold' : 'normal'),
                  fontFamily: option.style.dataLabelFormat.fontFamily,
                },
                itemStyle: {
                  borderWidth: option.style.barBorderWidth,
                  borderColor: option.style.barBorderColor,
                },
                barMaxWidth: option.style.barMaxWidth,
                barGap: '20%',
                barCategoryGap: '30%',
              });
            }
          });
          break;
        case 'LineChart':
          newOption.chartOption = {
            title: {
              show: option.data.isShowTitle,
              text: option.data.title || '图表标题',
              left: 'center',
              top: 'top',
              textStyle: {
                fontFamily: option.style.titleFormat.fontFamily,
                fontSize: option.style.titleFormat.fontSize,
                color: option.style.titleFormat.foreground,
                fontWeight: (option.style.titleFormat.isBold ? 'bold' : 'normal')
              }
            },
            color: option.style.colorSpace,
            legend: {
              show: option.data.isShowLegend,
              orient: (option.data.legendPosition === 0 ? 'vertical' : 'horizontal'),
              left: (option.data.legendPosition === 0 ? 'right' : 'center'),
              top: (option.data.legendPosition === 0 ? 'middle' : 'bottom'),
              align: 'left',
              textStyle: {
                fontFamily: option.style.legendStyle.labelFormat.fontFamily,
                fontSize: option.style.legendStyle.labelFormat.fontSize,
                color: option.style.legendStyle.labelFormat.foreground,
                fontWeight: (option.style.legendStyle.labelFormat.isBold ? 'bold' : 'normal')
              },
              itemWidth: option.style.legendStyle.colorBlockWidth,
              itemHeight: option.style.legendStyle.colorBlockHeight,
              data: []
            },
            grid: {
              bottom: (option.data.legendPosition === 0 ? 30 : 50),
              // width: option.style.dataAreaWidth,
              // height: option.style.axisStyle.dataAreaHeight
            },
            animation: false,
            xAxis: {
              type: 'category',
              boundaryGap: [0, 0.01],
              // name: '商品名称',
              // nameGap: 30,
              // nameLocation: 'center',
              data: [],
              axisLabel: {
                show: option.data.isShowGroupLabels,
                interval: 0,
                fontFamily: option.style.groupLabelFormat.fontFamily,
                fontSize: option.style.groupLabelFormat.fontSize,
                color: option.style.groupLabelFormat.foreground,
                fontWeight: (option.style.groupLabelFormat.isBold ? 'bold' : 'normal')
              },
              axisLine: {
                onZero: false,
                symbol: ['none', 'arrow'],
                symbolSize: [option.style.axisStyle.arrowWidth, option.style.axisStyle.arrowHeight],
                lineStyle: {
                  width: option.style.axisStyle.lineWidth,
                  color: option.style.axisStyle.lineColor
                }
              },
              axisTick: {
                show: false,
                alignWithLabel: true
              },
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                interval: 0,
                fontFamily: option.style.axisStyle.valueMarkerFormat.fontFamily,
                fontSize: option.style.axisStyle.valueMarkerFormat.fontSize,
                color: option.style.axisStyle.valueMarkerFormat.foreground,
                fontWeight: (option.style.axisStyle.valueMarkerFormat.isBold ? 'bold' : 'normal')
              },
              axisLine: {
                symbol: ['none', 'arrow'],
                symbolSize: [option.style.axisStyle.arrowWidth, option.style.axisStyle.arrowHeight],
                lineStyle: {
                  width: option.style.axisStyle.lineWidth,
                  color: option.style.axisStyle.lineColor
                }
              },
              axisTick: {
                inside: true,
                lineStyle: {
                  width: option.style.axisStyle.valueMarkerLineLength,
                }
              },
              splitLine: {
                show: false
              }
            },
            series: []
          };
          option.data.data[0].forEach(function (value, index) {
            if (parseFloat(value) >= 0) {
              newOption.chartOption.xAxis.data.push(option.data.groupLabels[index]);
            }
          });
          option.data.legendItemLabels.forEach(function (serie, index) {
            if (!option.data.data[index]) {
              return;
            }
            if (!isArrayEmpty(option.data.data[index])) {
              newOption.chartOption.legend.data.push({
                name: serie,
                icon: 'rect'
              });
            }
            newOption.chartOption.series.push({
              type: 'line',
              symbol: (option.style.dotShape === 0 ? 'circle' : (option.style.dotShape === 1 ? 'triangle' : 'rect')),
              symbolSize: [option.style.dotSizeWidth, option.style.dotSizeHeight],
              data: option.data.data[index],
              name: serie,
              label: {
                show: option.data.isShowDataValues,
                position: 'bottom',
                color: option.style.dataLabelFormat.foreground,
                fontSize: option.style.dataLabelFormat.fontSize,
                fontWeight: (option.style.dataLabelFormat.isBold ? 'bold' : 'normal'),
                fontFamily: option.style.dataLabelFormat.fontFamily,
              },
              lineStyle: {
                width: option.style.lineWidth
              }
            });
          });
          // option.data.groupLabels.forEach(function (index, category) {
          // });
          break;
        case 'PieChart':
          newOption.chartOption = {
            title: {
              show: option.data.isShowTitle,
              text: option.data.title || '图表标题',
              left: 'center',
              top: 'top',
              textStyle: {
                fontFamily: option.style.titleFormat.fontFamily,
                fontSize: option.style.titleFormat.fontSize,
                color: option.style.titleFormat.foreground,
                fontWeight: (option.style.titleFormat.isBold ? 'bold' : 'normal')
              }
            },
            color: option.style.colorSpace,
            animation: false,
            legend: {
              show: option.data.isShowLegend,
              orient: (option.data.legendPosition === 0 ? 'vertical' : 'horizontal'),
              left: (option.data.legendPosition === 0 ? 'right' : 'center'),
              top: (option.data.legendPosition === 0 ? 'middle' : 'bottom'),
              align: 'left',
              textStyle: {
                fontFamily: option.style.legendStyle.labelFormat.fontFamily,
                fontSize: option.style.legendStyle.labelFormat.fontSize,
                color: option.style.legendStyle.labelFormat.foreground,
                fontWeight: (option.style.legendStyle.labelFormat.isBold ? 'bold' : 'normal')
              },
              itemWidth: option.style.legendStyle.colorBlockWidth,
              itemHeight: option.style.legendStyle.colorBlockHeight,
              data: []
            },
            series: [
              {
                name: option.data.legendItemLabels[0],
                type: 'pie',
                // radius: '70%',
                // radius: option.style.radius,
                radius: '70%',
                center: ['50%', '50%'],
                data: [],
                label: {
                  show: option.data.isShowDataValues,
                  position: 'inside',
                  color: option.style.dataLabelFormat.foreground,
                  fontSize: option.style.dataLabelFormat.fontSize,
                  fontWeight: (option.style.dataLabelFormat.isBold ? 'bold' : 'normal'),
                  fontFamily: option.style.dataLabelFormat.fontFamily,
                  formatter: '{d}%'
                },
                itemStyle: {
                  borderWidth: option.style.borderWidth || 2,
                  borderColor: option.style.borderColor
                }
              }
            ]
          };
          option.data.data[0].forEach(function (value, index) {
            if (value) {
              newOption.chartOption.series[0].data.push({
                value: value,
                name: option.data.groupLabels[index]
              });
              newOption.chartOption.legend.data.push({
                name: option.data.groupLabels[index],
                icon: 'rect'
              });
            }
          });
          break;
        default:
          break;
      }

      return newOption.chartOption;
    }
  }
};



// WEBPACK FOOTER //
// ./src/plugins/chartFromJson.js